import React from 'react';
import { ArrowLeft, Check, Car } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { useNavigate } from 'react-router-dom';

const ServiceAutomobile = () => {
  const navigate = useNavigate();

  const exteriorFormulas = [
    {
      id: 1,
      name: "Formule Standard",
      price: "70€",
      services: [
        "Prélavage",
        "Lavage extérieur :",
        "• Vitres",
        "• Jantes",
        "• Pneus",
        "• Contour de porte"
      ]
    },
    {
      id: 2,
      name: "Formule Haut de Gamme",
      price: "140€",
      popular: true,
      services: [
        "Prélavage",
        "Lavage extérieur :",
        "• Vitres",
        "• Jantes",
        "• Pneus",
        "• Contour de porte",
        "• Produit démoustiquant",
        "• Produit anti-pluie",
        "• Nettoyant jantes"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4">
          <Button
            variant="ghost"
            onClick={() => navigate('/')}
            className="text-gray-700 hover:text-yellow-600"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Button>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-gray-100 to-gray-200 py-16">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center mb-6">
            <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center">
              <Car className="w-8 h-8 text-gray-900" />
            </div>
          </div>
          <h1 className="text-5xl font-bold text-center text-gray-900 mb-4">
            Nettoyage Automobile Extérieur
          </h1>
          <p className="text-xl text-center text-gray-600 max-w-3xl mx-auto">
            Redonnez à votre véhicule tout son éclat avec nos formules professionnelles de nettoyage extérieur
          </p>
        </div>
      </section>

      {/* Exterior Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Nos Formules EXTÉRIEUR</h2>
            <p className="text-lg text-gray-600">Choisissez la formule adaptée à vos besoins</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {exteriorFormulas.map((formula) => (
              <Card
                key={formula.id}
                className={`relative ${formula.popular ? 'border-4 border-yellow-500 shadow-2xl' : 'border-2 border-gray-200'}`}
              >
                {formula.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-yellow-500 text-gray-900 px-6 py-2 rounded-full font-bold text-sm shadow-lg">
                      ⭐ POPULAIRE
                    </span>
                  </div>
                )}
                <CardContent className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{formula.name}</h3>
                  <div className="text-4xl font-bold text-yellow-600 mb-6">{formula.price}</div>
                  <ul className="space-y-3">
                    {formula.services.map((service, index) => (
                      <li key={index} className="flex items-start">
                        <Check className="w-5 h-5 text-yellow-600 mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">{service}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-yellow-500 to-blue-500">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Prêt à redonner vie à votre véhicule ?
          </h2>
          <p className="text-xl text-white mb-8">
            Contactez-nous pour réserver votre formule
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button
              size="lg"
              className="bg-white text-gray-900 hover:bg-gray-100 font-semibold text-lg px-8 py-6"
              onClick={() => navigate('/?devis=automobile')}
            >
              Demander un Devis
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 font-semibold text-lg px-8 py-6"
              onClick={() => window.location.href = 'tel:0661994139'}
            >
              Appeler : 06.61.99.41.39
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceAutomobile;
